/* eslint-disable */
import axios from "@/axios";
import store from "@/store";

export function getRecipients({ params, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get("/recipients", { headers, params, signal });
}

export function createRecipient({ payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.post("/recipients", payload, { headers });
}

export function getRecipient({ numberOrId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/recipients/${numberOrId}`, { headers, signal });
}

export function updateRecipient({ numberOrId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.put(`/recipients/${numberOrId}`, payload, { headers });
}

export function deleteRecipient({ numberOrId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.delete(`/recipients/${numberOrId}`, { headers });
}

export function importRecipientFromExternalProvider({ payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.post("/recipients/import", payload, { headers });
}

export function getRecipientGeolocation({ numberOrId, locationId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/recipients/${numberOrId}/geolocations/${locationId}`, { headers, signal });
}

export function getRecipientGeolocations({ numberOrId, params, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/recipients/${numberOrId}/geolocations`, { headers, params, signal });
}

export function addRecipientGeolocation({ numberOrId, payload, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.post(`/recipients/${numberOrId}/geolocations`, payload, { headers, signal });
}

export function getConversationRecipients({ conversationId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.get(`/conversations/${conversationId}/recipients`, { headers, signal });
}

export function addRecipientToConversation({ conversationId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.put(`/conversations/${conversationId}/recipients`, payload, { headers });
}

export function removeRecipientFromConversation({ conversationId, recipientId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.delete(`/conversations/${conversationId}/recipients/${recipientId}`, { headers });
}

export function updateRecipientLanguage({ numberOrId, language }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.put(`/recipients/${numberOrId}/dialect/${language}`, {}, { headers });
}